import { IRootState, ISubscription, ISubscriptionsState } from '@/@types'

import CONSTANTS from '@/constants'
import { GetterTree } from 'vuex'

const getters: GetterTree<ISubscriptionsState, IRootState> = {
  activeSubscriptions: state => {
    return state.usersCurrentSubscriptionsWithPasses.filter(sub => sub.state === 'active')
  },
  skillDiveSubscription: (state, subscriptionsGetters) => {
    return subscriptionsGetters.activeSubscriptions.find((sub: ISubscription) =>
      [CONSTANTS.PLANS.SKILL_DIVE_ANNUAL, CONSTANTS.PLANS.SKILL_DIVE_PTA].includes(sub.plan_code)
    )
  },
  userHasSkillDive: (state, subscriptionsGetters) => {
    return !!subscriptionsGetters.skillDiveSubscription
  },
  hasSkillDiveCyberSecurity: (state, subscriptionsGetters) => {
    const { skillDiveSubscription }: { skillDiveSubscription: ISubscription } = subscriptionsGetters

    return skillDiveSubscription?.passes?.data?.some(
      pass => pass.addon_code === CONSTANTS.SKILL_DIVE_LEARNING_AREAS.CYBER_SECURITY
    )
  },
  hasSkillDiveNetworking: (state, subscriptionsGetters) => {
    const { skillDiveSubscription }: { skillDiveSubscription: ISubscription } = subscriptionsGetters

    return skillDiveSubscription?.passes?.data?.some(
      pass => pass.addon_code === CONSTANTS.SKILL_DIVE_LEARNING_AREAS.NETWORKING
    )
  },
  hasSkillDiveCloud: (state, subscriptionsGetters) => {
    const { skillDiveSubscription }: { skillDiveSubscription: ISubscription } = subscriptionsGetters
    return skillDiveSubscription?.passes?.data?.some(
      pass => pass.addon_code === CONSTANTS.SKILL_DIVE_LEARNING_AREAS.CLOUD
    )
  },
  hasSkillDiveFullLearningAreas: (state, subscriptionsGetters) => {
    const { hasSkillDiveCyberSecurity, hasSkillDiveNetworking, hasSkillDiveCloud } =
      subscriptionsGetters
    return hasSkillDiveCyberSecurity && hasSkillDiveNetworking && hasSkillDiveCloud
  },
  getPaymentEntries: state => {
    return state?.paymentEntries ?? null
  },
  getUsersCurrentSubscriptions: state => {
    return state.usersCurrentSubscriptions
  },
}

export default getters
